module.exports = __webpack_public_path__ + "static/media/zone_graphic_wide.5fe1b066.png";